import React, { useMemo } from 'react';
import { ToastContent } from 'react-toastify';
import { useTheme } from 'styled-components';
import { getColor, IconButton, Icon, Body2 } from '@invent/wl-ui-kit';
import { MessageWrapper } from './styled';

export interface INotificationPlatformFallbackProps {
  type: MessageInfoTypeT;
  content: ToastContent;
  onClose?: VoidFunction;
  refreshHandler?: VoidFunction;
}

function getIconNameByType(
  type: MessageInfoTypeT
): 'info_outline' | 'check_outline' | 'warning_amber' | 'close_outline' {
  const icons: {
    info: 'info_outline';
    success: 'check_outline';
    warning: 'warning_amber';
    error: 'close_outline';
  } = {
    info: 'info_outline',
    success: 'check_outline',
    warning: 'warning_amber',
    error: 'close_outline'
  };

  return icons[type];
}

function useColorByType(type: MessageInfoTypeT): string {
  const theme = useTheme();

  const colors: {
    info: string;
    success: string;
    warning: string;
    error: string;
  } = {
    info: getColor('primary')({ theme }),
    success: getColor('success')({ theme }),
    warning: getColor('warning')({ theme }),
    error: getColor('danger')({ theme })
  };

  return colors[type];
}

export const NotificationPlatformFallback = ({
  type,
  content,
  onClose
}: INotificationPlatformFallbackProps) => {
  const color = useColorByType(type);
  const iconName = useMemo(() => getIconNameByType(type), [type]);
  return (
    <MessageWrapper>
      <Icon size="medium" color={color} name={iconName} />
      <Body2>{content}</Body2>
      <IconButton onClick={onClose}>
        <Icon name="close" />
      </IconButton>
    </MessageWrapper>
  );
};
